<template>
<HeaderComponent/>
<router-view/>
<FooterComponent/>
</template>

<script>
import HeaderComponent from "@/components/includes/HeaderComponent.vue";
import FooterComponent from "@/components/includes/FooterComponent.vue";
export default {
  name : 'App',
  components:{HeaderComponent, FooterComponent}
}
</script>

<style>
</style>
